export const events = {
  eventsCardDurationText: 'Dauer',
  eventsSearchInputText: 'Suche',
  eventsRegisteredToEventAlertTitle: 'Erfolgreich registriert',
  eventsUnregisteredToEventAlertTitle: 'Erfolgreich abgemeldet',
  eventsExternalRegistrationPopupTitle: 'Registrieren',
  eventsExternalRegistrationPopupContent: 'Sind Sie erfolgreich registriert worden?',
  eventsExternalRegistrationNoButtonTitle: 'Nein',
  eventsExternalRegistrationYesButtonTitle: 'Ja',
  eventsCurtainCopyOptionTitle: 'Link kopieren',
  eventsCurtainFlagOptionTitle: 'Melden',
  eventsLinkCopiedAlertText: 'Link kopiert!',
  eventsCurtainAddToCalendOptionTitle: 'Zum Kalender hinzufügen',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'Auf Karte',
  eventdetailsOnlineLocationTitle: 'Online',
  eventdetailAmountsRegisteredText: 'Teilnehmer',
  eventdetailsSeeAllButtonTitle: 'Alle anzeigen',
  eventdetailsRegisteredButtonTitle: 'Registriert',
  eventdetailsRegisterButtonTitle: 'Registrieren',
  eventdetailsRegisteredAlertText: 'Erfolgreich registriert',
  eventdetailsUnregisteredAlertText: 'Erfolgreich abgemeldet',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Registrierte Benutzer',
  eventdetailsSpeakersCurtainTitle: 'Referenten',
  eventdetailsSpeakersSectionTitle: 'Referenten',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Alle anzeigen',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Alle anzeigen',
  eventdetailsCurtainCopyOptionTitle: 'Link kopieren',
  eventdetailsCurtainFlagOptionTitle: 'Melden',
  eventsdetailsLinkCopiedAlertText: 'Link kopiert!',
  eventdetailsCurtainAddToCalOptionTitle: 'Zum Kalender hinzufügen',
  eventDetailsAddCalendarPopupTitle: 'Kalender',
  eventdetailsAddCalendarPopupContent: 'Zum Kalender hinzufügen?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Nein',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Ja',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Link kopieren',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Melden',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Link kopiert!',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Link kopieren',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Melden',
  eventsFlag: 'Melden',
  eventsJoin: 'Teilnehmen',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Link kopiert!',
  eventContentReported: 'Inhalt gemeldet',
  eventsError: 'Etwas ist schief gelaufen!',
  eventdetailsExternalRegistrationPopupContent: 'Sind Sie erfolgreich registriert worden?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Nein',
  eventdetailsExternalRegistrationYesButtonTitle: 'Ja',
  eventdetailsExternalRegistrationPopupTitle: 'Registrieren',
  eventsCardRegisteredButtonTitle: 'Registriert',
  eventsCardRegisterButtonTitle: 'Registrieren',
  eventsJoinLink: 'Link zur Teilnahme: [url]{link}[/url][br]',
  eventsGuest: 'Gast',
  eventsNoSessionInDay: 'An diesem Tag gibt es keine Veranstaltungen.',
  eventsShowUpcomingEvent: 'Nächstes Ereignis anzeigen'
}
